import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const PartnerLicensePackageUsageRateGauge = (props) => (
  <KpiChart
    title="License package usage"
    description="The number represents the percentage of usage of the contracted license packages. It is important that the percentage is close to or greater than 100% because customers are paying for licenses."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[70, 80, 90, 100]}
    stepSize={10}
    reverseColors={false}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

PartnerLicensePackageUsageRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};
PartnerLicensePackageUsageRateGauge.defaultProps = {
  onClickHistory: null,
};

export default PartnerLicensePackageUsageRateGauge;
